<template>
  <div class="option-product">
    <option-product-checkbox
      v-if="useCheckbox"
      :catalog-package-option-id="packageOption.CatalogPackageOptionID"
      :package-option-product="optionProduct"
      :is-per-frame="packageOption.IsPerFrame"
      :option-index="packageOptionIndex"
      :product-index="optionProductIndex"
    />
    <option-product-radio
      v-if="useRadioButton"
      :catalog-package-option-id="packageOption.CatalogPackageOptionID"
      :package-option-product="optionProduct"
      :is-per-frame="packageOption.IsPerFrame"
      :has-custom-config="hasCustomConfig"
      :should-custom-config-show-selected-frame-image="shouldCustomConfigShowSelectedFrameImage"
      :custom-configured-products-model="customConfiguredProductsModel"
      :option-index="packageOptionIndex"
      :product-index="optionProductIndex"
    />
  </div>
</template>

<script>
import OptionProductCheckbox from './OptionProductCheckbox'
import OptionProductRadio from './OptionProductRadio'

export default {
  name: 'OptionProduct',
  components: {
    OptionProductCheckbox,
    OptionProductRadio
  },
  props: {
    optionProduct: { type: Object, default: null, required: true },
    packageOption: { type: Object, default: null, required: true },
    packageOptionIndex: { type: Number, default: null, required: true },
    optionProductIndex: { type: Number, default: null, required: true }
  },
  computed: {
    useCheckbox () {
      return this.packageOption.Max > this.packageOption.Min || ((this.packageOption.Max === this.packageOption.Min) && (this.packageOption.Min === 0 && this.packageOption.Max === 0))
    },
    useRadioButton () {
      return this.packageOption.Max === this.packageOption.Min && this.packageOption.Min === 1
    },
    hasCustomConfig () {
      // return this.optionProduct.ProductInterface.CustomConfigurationPartialViewName !== undefined && this.optionProduct.ProductInterface.CustomConfigurationPartialViewName !== null && this.$store.state.selectedFrameId !== null
      return false // need to figure out how to compute this in a way that this.optionProduct.ProductInterface serialization doesn't break the product builder
    },
    shouldCustomConfigShowSelectedFrameImage () {
      /* need to figure out how to compute this in a way that this.optionProduct.ProductInterface serialization doesn't break the product builder
      if (this.optionProduct.ProductInterface.ShouldCustomConfigShowSelectedFrameImage !== undefined && this.optionProduct.ProductInterface.ShouldCustomConfigShowSelectedFrameImage !== null) {
        return this.optionProduct.ProductInterface.ShouldCustomConfigShowSelectedFrameImage
      }
      */

      return false
    },
    customConfiguredProductsModel () {
      /*
        This is not yet supported in this component.
        When it is needed, will need to attach the C# generated model to the optionProduct
        or package option in the _PackageOptions.cshtml partial
      */

      return null
    }
  }
}
</script>

<style lang="scss">
.option-product {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d9d9d9;

  &:last-of-type {
    margin-bottom: 0;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProduct.vue